import { useEffect, lazy, Suspense } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import BrandBackground from "@/components/BrandBackground";
import PageMeta from "@/components/PageMeta";
import { useLanguage } from "@/contexts/LanguageContext";

// Lazy-load below-the-fold components to reduce initial JS bundle
const Benefits = lazy(() => import("@/components/Benefits"));
const FeaturedProjects = lazy(() => import("@/components/FeaturedProjects"));
const HowItWorks = lazy(() => import("@/components/HowItWorks"));
const SocialProof = lazy(() => import("@/components/SocialProof"));
const FAQ = lazy(() => import("@/components/FAQ"));
const Newsletter = lazy(() => import("@/components/Newsletter"));
const ContactCTA = lazy(() => import("@/components/ContactCTA"));
const NewsletterPopup = lazy(() => import("@/components/NewsletterPopup"));

const Index = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      // Lazy-loaded sections may not exist yet — poll until the element appears
      let attempts = 0;
      const maxAttempts = 20;
      const poll = setInterval(() => {
        const el = document.querySelector(location.hash);
        attempts++;
        if (el) {
          clearInterval(poll);
          el.scrollIntoView({ behavior: "smooth" });
        } else if (attempts >= maxAttempts) {
          clearInterval(poll);
        }
      }, 150);
      return () => clearInterval(poll);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.hash]);

  return (
    <div className="min-h-screen relative">
      <PageMeta
        title="Expert Welding Solutions"
        description="From cost-optimized welding machines to fully customized premium solutions — engineered to fit your process, not a catalog."
      />
      <BrandBackground />
      <Header />
      <Hero />
      <Suspense fallback={null}>
        <Benefits />
        <FeaturedProjects />
        <HowItWorks />
        <SocialProof />
        <FAQ />
        <Newsletter />
        <ContactCTA />
        <NewsletterPopup />
      </Suspense>
    </div>
  );
};

export default Index;
